module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t3-8.7cdcc6fc.svg";